import EA from 'helpers/init';

export default EA.Methods.lazyLoadSwiper = ($this) => {
    const swiperSection = $this;
    const images = $this.querySelectorAll('img');
    let observer;

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                for (let i = 0; i < images.length; i++) {                    
                    images[i].src = images[i].dataset.src;
                    observer.disconnect();
                }
            }
        });
    }

    function createObserver() {
        const options = {
            root: null,
            rootMargin: '-10px',
            threshold: 0,
        };

        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(swiperSection);
    }

    createObserver();
};

